import React from 'react';

const MindLifeLogo = ({ height = '50px', showText = true, className = '' }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: showText ? '0.75rem' : '0' }} className={className}>
      {/* Logo Real de Mind Life - Con fondo transparente */}
      <img 
        src="https://customer-assets.emergentagent.com/job_psycenter/artifacts/90cxrvpx_Gemini_Generated_Image_vqm98avqm98avqm9-removebg-preview.png"
        alt="Mind Life Centro Psicológico"
        style={{ height: height, width: 'auto' }}
      />
    </div>
  );
};

export default MindLifeLogo;
